import React, { useEffect, useState } from 'react';

import Actions from '../action';
import Selectors from '../selectors';
import SummaryPresentational from './summaryPresentational';
import { connect } from 'react-redux';

const SummaryFunctional = ({ buttonMode, buttonName, getfeeStart, feeData, isFeeLoading }) => {
	useEffect(() => {
		buttonMode?.('single');
		buttonName?.('Next');
		getfeeStart();
	}, []);

	return (
		<>
			<SummaryPresentational feeData={feeData} isFeeLoading={isFeeLoading}></SummaryPresentational>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		feeData: Selectors.feeData(state),
		isFeeLoading: Selectors.isFeeLoading(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getfeeStart: () => dispatch(Actions.creators.getfeeStart()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(SummaryFunctional);
export default Connected;
